import gql from "graphql-tag";

export const GET_ADMIN_SETTINGS = gql`
	query GetAdminSettings {
		adminSettings {
			id
			defaultExtractorSetId
			defaultValidatorSetId
			defaultOnChangeHandlerSetId
			defaultExporterSetId
			mailExporterSetId
			mailFromAddresses {
				id
				mailAddress
			}
		}
	}
`;

export const GET_ADMIN_EXTRACTOR_SETS = gql`
	query GetAdminExtractorSets {
		adminExtractorSets {
			id
			code
			description
			extractors {
				id
				order
				extractorType
				settings
				description
			}
		}
	}
`;

export const GET_ADMIN_VALIDATOR_SETS = gql`
	query GetAdminValidatorSets {
		adminValidatorSets {
			id
			code
			description
			validators {
				id
				order
				validatorType
				settings
				description
			}
		}
	}
`;

export const GET_ADMIN_EXPORTER_SETS = gql`
	query GetAdminExporterSets {
		adminExporterSets {
			id
			code
			description
			exporters {
				id
				order
				code
				exporterType
				settings
				description
			}
		}
	}
`;

export const GET_ADMIN_ON_CHANGE_HANDLER_SETS = gql`
	query GetAdminOnChangeHandlerSets {
		adminOnChangeHandlerSets {
			id
			code
			description
			onChangeHandlers {
				id
				order
				onChangeHandlerType
				settings
				description
			}
		}
	}
`;

export const GET_ADMIN_LOOKUPS = gql`
	query GetAdminLookups($type: String!) {
		adminLookups(type: $type) {
			id
			type
			code
			description
			disabled
		}
	}
`;

export const GET_ADMIN_LOOKUP_TYPES = gql`
	query GetAdminLookupTypes {
		adminLookupTypes
	}
`;
